import React, {
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { BusinessContextProvider } from '../context/BusinessContext';

export type WebUxContextData = {
  title: React.ReactNode;
  setTitle: (title: React.ReactNode) => void;
};

export const WebUxContext = React.createContext<WebUxContextData>({} as any);

export const WebUxContextProvider: FC<PropsWithChildren> = (props) => {
  const [title, setTitle] = useState<React.ReactNode>('');

  return (
    <WebUxContext.Provider value={{ title, setTitle }}>
      <BusinessContextProvider>{props.children}</BusinessContextProvider>
    </WebUxContext.Provider>
  );
};

export const useWebUxContext = () => useContext(WebUxContext);

export const WebUxTitle: FC<PropsWithChildren> = (props) => {
  const ctx = useWebUxContext();
  useEffect(() => {
    ctx.setTitle(props.children);
  });
  return <></>;
};
